import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {CardText} from 'reactstrap'

const potentialMultipleOfferItems = [
  {key: "actionZone", label: "Périmètre"},
  {key: "goals", label: "Objectifs"},
  {key: "achievements", label: "Réalisations"},
  {key: "results", label: "Résultats"},
]

export default class OfferExampleDetail extends PureComponent {
  static propTypes = {
    card: PropTypes.bool,
    offer: PropTypes.object.isRequired,
  }

  static defaultProps = {
    card: true,
  }

  render() {
    const {offer, card} = this.props

    if (!offer) {
      return null
    }

    const Wrapper = card ? CardText : 'p'

    return <div className="offer-example-detail">
      <Wrapper><span className="title">Contexte : </span>{offer.context}</Wrapper>
      {potentialMultipleOfferItems.map((item) => {
        const items = offer?.[item.key]?.length ? offer[item.key] : []

        if (items.length === 0) {
          return null
        }

        const label = <span className="title">{item.label} : </span>

        if (items.length === 1) {
          return <Wrapper className={card ? 'd-none d-lg-block' : null} key={item.key}>{label}{items.toString()}</Wrapper>
        }

        return <div className={card ? 'd-none d-lg-block' : null} key={item.key}>
          <Wrapper>{label}</Wrapper>
          <ul>
            {items.map((listItem, index) => <li key={index}>{listItem}</li>)}
          </ul>
        </div>
      })}
    </div>
  }
}
